import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { ADMIN_AFFILIATE_TRACKERS_SETTINGS_ROUTE_NAME } from '@modules/affiliates-approved/submodules/trackers-settings/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_LIST_ROUTE_NAME,
  ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_TRACKERS,
} from './constants';
import { AffiliatesApprovedFixedTrackerPaymentsModule } from './submodules/fixed-tracker-payments/FixedTrackerPaymentsModule';
import { AffiliatesApprovedTrackersSettingsTrackerDealChangesModule } from './submodules/tracker-deal-changes/TrackerDealChangesModule';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedTrackersSettingsListModule extends AppModule {
  protected submodules: AppModule[] = [
    new AffiliatesApprovedTrackersSettingsTrackerDealChangesModule(),
    new AffiliatesApprovedFixedTrackerPaymentsModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATE_TRACKERS_SETTINGS_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_ROUTE_NAME,
      path: 'trackers',
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      redirect: { name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_LIST_ROUTE_NAME },
    });

    router.addChildRoute(ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_TRACKERS_SETTINGS_TRACKERS_LIST_ROUTE_NAME,
      path: '',
      component: () => import('./pages/TrackersSettingsListPage/TrackersSettingsListPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_TRACKERS, getTranslationKeys);
  }
}
